import { useEffect, useState, useRef, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import socketIOClient from "socket.io-client";

const useChat = () => {
  // const { ticketId } = useParams();
  const socketRef = useRef();
  const [messages, setMessages] = useState([]);

  const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }

  let searchParams = useQuery();

  let ticketId = searchParams.get("ticketId");

  //when component mounts and changes
  useEffect(() => {
    socketRef.current = socketIOClient(process.env.REACT_APP_API_SOCKET_URL, {
      query: { ticketId }
    });

    socketRef.current.on("mostRecentMessages", (mostRecentMessages) => {
      //on start, set as messages the mostRecentMessages
      //in case the server restarts, we want to replace the current messages
      //with those from database
      //not add more
      setMessages(messages => [...mostRecentMessages]);
    });

    socketRef.current.on("support-user-send-message", ({ message, status, to, chat_id }) => {
      //append message to the end of array, after using spread operator
      setMessages(messages => [...messages, { message: message, status: status, to: to, chat_id: chat_id }]);

      //this will not work
      //useeffect runs once, when the component first loads
      //acts as closure that has access to messages (parent scope)
      //when it first runs, messages is empty array
      //when you add new messages to the messages array, it is no longer empty
      //and the array is changed (not mutated, new array)
      //with this way you're no longer able to access the current value of messages here
      //you would have access only to the first value of messages (empty array)
      //and means you won't be able to append more messages
      //so instead we use the above, that's we use a callback that will get the latest value of messages
      //and then appends the latest data
      //setMessages([...messages, message])
    })

    return () => {
      socketRef.current.disconnect();
    }
  }, []);

  //message is part of an object
  const sendMessage = (messageObject) => {
    socketRef.current.emit("support-user-send-message", messageObject);
    setMessages(messages => [...messages, messageObject]);
  }

  return { messages, sendMessage };
}

export default useChat;